import type FavoritesStore from "./schema/FavoritesStore";
import { createStore } from "owa-satcheljs";

const defaultFavoritesStore: FavoritesStore = {
    orderedCombinedOutlookFavoritesIds: [],
    outlookFavorites: new Map(),
    favoriteSecondaryKeyMap: new Map(),
    favoritingInProgressMap: new Map(),
    favoriteTreeData: new Map(),
    unusedFavorites: new Map(),
    unusedFavoriteKeyMap: new Map(),
};

const getStore: () => FavoritesStore = createStore<FavoritesStore>("favorites", defaultFavoritesStore);
export default getStore;
export { getStore };
